import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.festivitiesTable],
        config: {
            headerName: getLocalizedString("tableType"),
            field: "type",
            isObligatory: true,
            isSelect: true,
        }
    },
    {
        pages: [paths.festivitiesTable],
        config: {
            headerName: getLocalizedString("year"),
            field: "year",
            isObligatory: true,
            maxLength: 4,
            minLength: 1,
        }
    },
    {
        pages: [paths.festivitiesTable],
        config: {
            headerName: getLocalizedString("startDate"),
            field: "startDate",
            cellEditor: "dateEditor",
            filter: "agTextColumnFilter",
            isDate: true,
            isObligatory: true,
            dataType: "date",
        }
    },
    {
        pages: [paths.festivitiesTable],
        config: {
            headerName: getLocalizedString("endDateAlt"),
            field: "endDate",
            cellEditor: "dateEditor",
            filter: "agTextColumnFilter",
            isDate: true,
            isObligatory: true,
            dataType: "date"
        }
    },
    {
        pages: [paths.festivitiesTable],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            isObligatory: true,
            maxLength: 50,
            minLength: 1
        }
    },
]